const baseTreatmentsCatalog = [
  {
    slug: "preenchimento-labial",
    name: "Preenchimento labial",
    category: "Harmonizacao facial",
    description: "Volume natural e contorno harmonico.",
    details:
      "Protocolo voltado para definir contorno, melhorar hidratacao e equilibrar volume dos labios com resultado elegante e proporcional ao rosto.",
    highlights: ["Contorno labial", "Volume equilibrado", "Hidratacao e definicao"],
    album: [
      { src: "/images/boca24.JPG", label: "Registro 1" },
      { src: "/images/boca25.JPG", label: "Registro 2" },
      { src: "/images/boca26.JPG", label: "Registro 3" },
      { src: "/images/boca29.JPG", label: "Registro 4" },
      { src: "/images/boca28.JPG", label: "Registro 5" },
      { src: "/images/boca10.JPG", label: "Registro 6" },
      { src: "/images/boca19.JPG", label: "Registro 7" },
      { src: "/images/boca21.JPG", label: "Registro 8" },
    ],
  },
  {
    slug: "jato-de-plasma",
    name: "Jato de plasma",
    category: "Rejuvenescimento",
    description: "Firmeza pontual com efeito progressivo.",
    details:
      "Tecnica para melhorar flacidez localizada e qualidade da pele em areas estrategicas, com planejamento conforme objetivo estetico.",
    highlights: ["Firmeza localizada", "Estimulo de reparacao", "Plano individual"],
    album: [
      { src: "/images/jato1.JPG", label: "Registro 1" },
      { src: "/images/jato2.JPG", label: "Registro 2" },
      { src: "/images/jato3.JPG", label: "Registro 3" },
      { src: "/images/jato4.JPG", label: "Registro 4" },
      { src: "/images/jato14.JPG", label: "Registro 5" },
      { src: "/images/jato13.JPG", label: "Registro 6" },
      { src: "/images/jato9.JPG", label: "Registro 7" },
      { src: "/images/jato7.JPG", label: "Registro 8" },
    ],
  },
  {
    slug: "bioestimuladores",
    name: "Bioestimuladores",
    category: "Rejuvenescimento",
    description: "Colageno para sustentacao gradual.",
    details:
      "Procedimento indicado para estimular colageno e melhorar sustentacao da pele de forma progressiva, preservando naturalidade.",
    highlights: ["Estimulo de colageno", "Melhora de firmeza", "Evolucao progressiva"],
    album: [
      { src: "/images/bio1.jpeg", label: "Registro 1" },
      { src: "/images/bio2.jpeg", label: "Registro 2" },
      { src: "/images/bio3.jpeg", label: "Registro 3" },
      { src: "/images/bio4.jpeg", label: "Registro 4" },
      { src: "/images/bio5.jpeg", label: "Registro 5" },
      { src: "/images/bio6.jpeg", label: "Registro 6" },
      { src: "/images/bio7.jpeg", label: "Registro 7" },
      { src: "/images/bio8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "fios-de-pdo",
    name: "Fios de PDO",
    category: "Harmonizacao facial",
    description: "Suporte e definicao de contorno.",
    details:
      "Fios de sustentacao para reposicionamento suave dos tecidos e melhoria de contorno, seguindo estrategia individualizada.",
    highlights: ["Suporte estrutural", "Contorno facial", "Resultado progressivo"],
    album: [
      { src: "/images/pdo1.jpeg", label: "Registro 1" },
      { src: "/images/pdo2.jpeg", label: "Registro 2" },
      { src: "/images/pdo3.jpeg", label: "Registro 3" },
      { src: "/images/pdo4.jpeg", label: "Registro 4" },
      { src: "/images/pdo5.jpeg", label: "Registro 5" },
      { src: "/images/pdo6.jpeg", label: "Registro 6" },
      { src: "/images/pdo7.jpeg", label: "Registro 7" },
      { src: "/images/pdo8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "micropigmentacao-labial",
    name: "Micropigmentacao labial",
    category: "Cuidados da pele",
    description: "Cor e definicao com naturalidade.",
    details:
      "Tecnica para valorizar o desenho labial e realcar tonalidade, buscando acabamento natural e harmonico com o perfil da paciente.",
    highlights: ["Realce de cor", "Definicao de contorno", "Acabamento natural"],
    album: [
      { src: "/images/cor1.JPG", label: "Registro 1" },
      { src: "/images/cor2.JPG", label: "Registro 2" },
      { src: "/images/cor3.JPG", label: "Registro 3" },
      { src: "/images/cor4.JPG", label: "Registro 4" },
      { src: "/images/cor5.JPG", label: "Registro 5" },
      { src: "/images/cor6.JPG", label: "Registro 6" },
      { src: "/images/cor7.JPG", label: "Registro 7" },
      { src: "/images/cor8.JPG", label: "Registro 8" },
    ],
  },
  {
    slug: "microagulhamento-exossomos-pdrn",
    name: "Microagulhamento com Exossomos e PDRN",
    category: "Cuidados da pele",
    description: "Reparacao avancada para textura e vico.",
    details:
      "Associacao de tecnologias para estimular renovacao cutanea e melhorar textura, luminosidade e qualidade global da pele.",
    highlights: ["Renovacao da pele", "Melhora de textura", "Mais luminosidade"],
    album: [
      { src: "/images/micro1.jpeg", label: "Registro 1" },
      { src: "/images/micro2.jpeg", label: "Registro 2" },
      { src: "/images/micro3.jpeg", label: "Registro 3" },
      { src: "/images/micro4.jpeg", label: "Registro 4" },
      { src: "/images/micro5.jpeg", label: "Registro 5" },
      { src: "/images/micro6.jpeg", label: "Registro 6" },
      { src: "/images/micro7.jpeg", label: "Registro 7" },
      { src: "/images/micro8.jpg", label: "Registro 8" },
    ],
  },
  {
    slug: "botox",
    name: "Botox",
    category: "Rejuvenescimento",
    description: "Suavizacao leve das linhas de expressao.",
    details:
      "Tratamento para suavizar linhas dinamicas e preservar naturalidade da expressao facial com tecnica e controle de dose.",
    highlights: ["Linhas de expressao", "Naturalidade", "Prevencao e suavizacao"],
    album: [
      { src: "/images/bt1.JPG", label: "Registro 1" },
      { src: "/images/bt2.JPG", label: "Registro 2" },
      { src: "/images/bt3.JPG", label: "Registro 3" },
      { src: "/images/bt4.JPG", label: "Registro 4" },
      { src: "/images/bt5.JPG", label: "Registro 5" },
      { src: "/images/bt6.JPG", label: "Registro 6" },
      { src: "/images/bt7.JPG", label: "Registro 7" },
      { src: "/images/bt8.JPG", label: "Registro 8" },
    ],
  },
  {
    slug: "peeling-de-ata",
    name: "Peeling de ATA",
    category: "Cuidados da pele",
    description: "Renovacao de textura e tom.",
    details:
      "Protocolo de renovacao cutanea para ajudar na uniformizacao do tom e melhora da textura, conforme indicacao profissional.",
    highlights: ["Uniformizacao de tom", "Textura da pele", "Renovacao progressiva"],
    album: [
      { src: "/images/pee1.jpeg", label: "Registro 1" },
      { src: "/images/pee2.jpeg", label: "Registro 2" },
      { src: "/images/pee3.jpeg", label: "Registro 3" },
      { src: "/images/pee4.jpeg", label: "Registro 4" },
      { src: "/images/pee5.jpeg", label: "Registro 5" },
      { src: "/images/pee6.jpeg", label: "Registro 6" },
      { src: "/images/pee7.jpeg", label: "Registro 7" },
      { src: "/images/pee8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "drenagem-linfatica",
    name: "Drenagem linfatica",
    category: "Estetica corporal",
    description: "Reducao de inchaco e leveza corporal.",
    details:
      "Tecnica manual para auxiliar na reducao de retencao, promover conforto corporal e contribuir para o bem-estar no dia a dia.",
    highlights: ["Leveza corporal", "Reducao de retencao", "Conforto diario"],
    album: [
      { src: "/images/dre1.jpeg", label: "Registro 1" },
      { src: "/images/dre2.jpeg", label: "Registro 2" },
      { src: "/images/dre3.jpeg", label: "Registro 3" },
      { src: "/images/dre4.jpeg", label: "Registro 4" },
      { src: "/images/dre5.jpeg", label: "Registro 5" },
      { src: "/images/dre6.jpeg", label: "Registro 6" },
      { src: "/images/dre7.jpeg", label: "Registro 7" },
      { src: "/images/dre8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "protocolos-queda-de-cabelo",
    name: "Protocolos para queda de cabelo",
    category: "Protocolos personalizados",
    description: "Abordagem personalizada para fortalecimento capilar.",
    details:
      "Plano combinado para reduzir queda e estimular fortalecimento dos fios, respeitando fase de tratamento e rotina individual.",
    highlights: ["Fortalecimento capilar", "Plano individual", "Acompanhamento de evolucao"],
    album: [
      { src: "/images/queda1.JPG", label: "Registro 1" },
      { src: "/images/queda2.JPG", label: "Registro 2" },
      { src: "/images/queda3.JPG", label: "Registro 3" },
      { src: "/images/queda4.JPG", label: "Registro 4" },
      { src: "/images/queda5.JPG", label: "Registro 5" },
      { src: "/images/queda6.JPG", label: "Registro 6" },
      { src: "/images/queda7.JPG", label: "Registro 7" },
      { src: "/images/queda8.JPG", label: "Registro 8" },
    ],
  },
  {
    slug: "protocolos-emagrecimento",
    name: "Protocolos de emagrecimento",
    category: "Estetica corporal",
    description: "Plano individual para seu objetivo.",
    details:
      "Estrategias integradas para contorno corporal e composicao estetica, com combinacao de tecnicas conforme objetivo.",
    highlights: ["Planejamento individual", "Combinacao de tecnicas", "Evolucao acompanhada"],
    album: [
      { src: "/images/mag1.jpeg", label: "Registro 1" },
      { src: "/images/mag2.jpeg", label: "Registro 2" },
      { src: "/images/mag3.jpeg", label: "Registro 3" },
      { src: "/images/mag4.jpeg", label: "Registro 4" },
      { src: "/images/mag5.jpeg", label: "Registro 5" },
      { src: "/images/mag6.jpeg", label: "Registro 6" },
      { src: "/images/mag7.jpeg", label: "Registro 7" },
      { src: "/images/mag8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "mesoterapia",
    name: "Mesoterapia",
    category: "Cuidados da pele",
    description: "Aplicacao personalizada para revitalizacao e suporte tecidual.",
    details:
      "Tecnica com ativos selecionados para suporte tecidual, revitalizacao e melhora global da qualidade da pele.",
    highlights: ["Revitalizacao", "Ativos personalizados", "Suporte tecidual"],
    album: [
      { src: "/images/meso1.jpeg", label: "Registro 1" },
      { src: "/images/meso2.jpeg", label: "Registro 2" },
      { src: "/images/meso3.jpeg", label: "Registro 3" },
      { src: "/images/meso4.jpeg", label: "Registro 4" },
      { src: "/images/meso5.jpg", label: "Registro 5" },
      { src: "/images/meso6.jpeg", label: "Registro 6" },
      { src: "/images/meso7.jpeg", label: "Registro 7" },
      { src: "/images/meso8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "micropigmentacao-sobrancelhas",
    name: "Micropigmentacao de sobrancelhas",
    category: "Harmonizacao facial",
    description: "Definicao e simetria com acabamento natural.",
    details:
      "Procedimento para ajustar desenho e simetria das sobrancelhas, respeitando proporcao facial e estilo desejado.",
    highlights: ["Simetria", "Definicao", "Naturalidade"],
    album: [
      { src: "/images/so1.JPG", label: "Registro 1" },
      { src: "/images/so2.JPG", label: "Registro 2" },
      { src: "/images/so3.JPG", label: "Registro 3" },
      { src: "/images/so4.JPG", label: "Registro 4" },
      { src: "/images/so5.JPG", label: "Registro 5" },
      { src: "/images/so6.JPG", label: "Registro 6" },
      { src: "/images/so7.JPG", label: "Registro 7" },
      { src: "/images/so8.JPG", label: "Registro 8" },
      { src: "/images/so9.JPG", label: "Registro 9" },
      { src: "/images/so10.JPG", label: "Registro 10" },
      { src: "/images/so11.JPG", label: "Registro 11" },
      { src: "/images/so12.JPG", label: "Registro 12" },
    ],
  },
  {
    slug: "clareamento-cutaneo",
    name: "Protocolos de clareamento cutaneo",
    category: "Cuidados da pele",
    description: "Uniformizacao gradual do tom com abordagem segura.",
    details:
      "Protocolos para auxiliar na uniformizacao de manchas e melhorar luminosidade geral da pele de forma progressiva.",
    highlights: ["Uniformizacao de tom", "Mais luminosidade", "Acompanhamento tecnico"],
    album: [
      { src: "/images/cla1.jpeg", label: "Registro 1" },
      { src: "/images/cla2.jpeg", label: "Registro 2" },
      { src: "/images/cla3.jpeg", label: "Registro 3" },
      { src: "/images/cla4.jpeg", label: "Registro 4" },
      { src: "/images/cla5.jpeg", label: "Registro 5" },
      { src: "/images/cla6.jpeg", label: "Registro 6" },
      { src: "/images/cla7.jpeg", label: "Registro 7" },
      { src: "/images/cla8.jpeg", label: "Registro 8" },
    ],
  },
  {
    slug: "flacidez-corporal",
    name: "Tratamento para flacidez corporal",
    category: "Estetica corporal",
    description: "Protocolos para firmeza e melhora do contorno corporal.",
    details:
      "Abordagem para melhorar tonus e firmeza corporal, com associacao de tecnicas indicadas conforme area e objetivo.",
    highlights: ["Melhora de firmeza", "Contorno corporal", "Plano personalizado"],
    album: [
      { src: "/images/fla1.jpeg", label: "Registro 1" },
      { src: "/images/fla2.jpeg", label: "Registro 2" },
      { src: "/images/fla3.jpeg", label: "Registro 3" },
      { src: "/images/fla4.jpeg", label: "Registro 4" },
      { src: "/images/fla5.jpeg", label: "Registro 5" },
      { src: "/images/fla6.jpeg", label: "Registro 6" },
      { src: "/images/fla7.jpeg", label: "Registro 7" },
      { src: "/images/fla8.jpeg", label: "Registro 8" },
    ],
  },
];

const ensureEightAlbumRecords = (album) => {
  if (!Array.isArray(album) || album.length >= 8) {
    return album || [];
  }

  const fallback = [{ src: "/images/pelefoto.jpg", label: "Registro 1" }];
  const sourceItems = album.length ? album : fallback;
  const missing = 8 - album.length;

  const extraItems = Array.from({ length: missing }, (_, index) => {
    const source = sourceItems[index % sourceItems.length];
    return {
      ...source,
      label: `Registro ${album.length + index + 1}`,
    };
  });

  return [...album, ...extraItems];
};

export const treatmentsCatalog = baseTreatmentsCatalog.map((item) => ({
  ...item,
  album: ensureEightAlbumRecords(item.album),
}));

export const getTreatmentBySlug = (slug) =>
  treatmentsCatalog.find((item) => item.slug === slug);
